// src/components/Footer.js
import React from 'react';

function Footer() {
    return (
        <footer className="bg-teal text-white p-4 text-center">
            <p>&copy; 2024 Euroactive. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
